<template>
  <div class="card">
    <div class="title">{{ title }}</div>
    <div class="body">
      <slot/>
    </div>
  </div>
</template>

<script>
  import { Vue, Component, Prop } from 'vue-property-decorator';

  @Component
  export default class Card extends Vue {
    @Prop(String) title // 卡片标题
  }
</script>

<style lang="scss" scoped>
  .card {
    padding: 35px;
    border-radius: 6px;
    background: var(--bg-primary-gray);

    @include media-xs-only {
      padding: 27px 16px 20px;
      margin-bottom: 28px;
    }

    .title {
      font-size: 18px;
      font-family: 'Radwave-Regular';
      color: var(--font-primary-red);
    }

    .body {
      padding: 40px 0;

      @include media-xs-only {
        padding: 20px 0;
      }
    }
  }
</style>
